import type { StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { Grid, GridItem } from '@repo/pandacss/styled-system/jsx';
import { FeatureViewed } from '@repo/segment/components/FeatureViewed';
import Image from 'next/image';
import type { PostAuthor } from '../../hydration/FirstPersonPerspectiveItem/schema';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';

type PerspectiveItemProps = StructuredContentDocument<{
  children: StructuredContentDocument;
  author: PostAuthor;
  rendererProps?: RendererProps;
}>;

export function FirstPersonPerspectiveItem({ props }: PerspectiveItemProps) {
  const { children, author, rendererProps } = props;
  const authorMedia = author.featuredMedia;

  return (
    <FeatureViewed entitySection="banking" entityName="first-person-perspective-item">
      <div
        className={css({
          width: 'full',
          backgroundColor: 'green.light',
          borderTopLeftRadius: '3',
          borderTopRightRadius: '3',
          borderBottomRightRadius: '3',
          borderBottomLeftRadius: '3',
          height: 'full',
        })}
      >
        <Grid
          gridTemplateColumns="repeat(12, minmax(0, 1fr))"
          className={css({
            paddingInlineStart: '7',
            paddingInlineEnd: '7',
            paddingBlockStart: '4',
            paddingBlockEnd: '4',
            rowGap: '4',
            columnGap: { sm: '4', md: '0' },
          })}
        >
          <GridItem
            colSpan={{ base: 12, sm: 9, md: 10 }}
            className={css({
              paddingRight: '4',
            })}
          >
            <div
              className={css({
                paddingLeft: '4',
                borderLeftWidth: 'thick',
                borderLeftColor: 'green.lighter',
                borderLeftStyle: 'solid',
              })}
            >
              {renderStructuredContent(children, rendererProps)}
            </div>
          </GridItem>
          <GridItem colSpan={{ base: 12, sm: 2 }}>
            <div
              className={css({
                display: 'flex',
                flexDirection: { base: 'row', sm: 'column' },
                alignItems: { base: 'flex-start', sm: 'center' },
                columnGap: '2',
                rowGap: '2',
              })}
            >
              {authorMedia && authorMedia.croppedImage && (
                <div
                  className={css({
                    position: 'relative',
                    borderTopLeftRadius: 'half',
                    borderTopRightRadius: 'half',
                    borderBottomRightRadius: 'half',
                    borderBottomLeftRadius: 'half',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: { base: '[60px]', sm: '[111px]' },
                    height: { base: '[60px]', sm: '[111px]' },
                  })}
                >
                  <Image
                    alt={`${author.fullName}'s profile picture`}
                    src={authorMedia?.croppedImage?.sourceUrl}
                    fill
                    style={{ objectFit: 'cover' }}
                  />
                </div>
              )}
              <span className={css({ textStyle: 'bodySmall' })}>{author.fullName}</span>
            </div>
          </GridItem>
        </Grid>
      </div>
    </FeatureViewed>
  );
}
